export const CASES_ID_REDIRECT = [59, 61];
export const FARM_CASE_IDS = [72, 74, 75, 59, 61];
export const ARCANE_LVLS = [15, 30, 45];
export const EVENT_GIFT_CASE_IDS = [57, 60];
export const FINAL_LVL = 60;
